import { render, staticRenderFns } from "./CategoryColorPreview.vue?vue&type=template&id=c768f13c&scoped=true&"
import script from "./CategoryColorPreview.vue?vue&type=script&lang=js&"
export * from "./CategoryColorPreview.vue?vue&type=script&lang=js&"
import style0 from "./CategoryColorPreview.vue?vue&type=style&index=0&id=c768f13c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c768f13c",
  null
  
)

export default component.exports